import React, { useCallback, useLayoutEffect, useRef, useState } from "react"

import VirtualGridWrapper from "./VirtualGridWrapper"

const responsive = (breakPoints) => {
  if (!breakPoints) return

  const sortedBreakPoints =
    breakPoints.sort((a, b) => {
      if (a.point >= b.point) return -1

      return 1
    })

  for (let breakPoint of sortedBreakPoints) {
    if (window.innerWidth >= breakPoint.point)
      return breakPoint
  }

  return breakPoints[breakPoints.length - 1]
}

const SectionVirtualGrid = (props) => {
  const {
    id,
    data,
    keyField,
    offset = 2,
    renderItem,
    breakPoints,
    className,
    sectionTitleHeight,
    sectionTitle,
    headerComponent,
    sameHeightAndWidth,
    listEmptyComponent = null
  } = props

  const [itemHeight, setItemHeight] = useState(null)
  const [currentBreakPoint, setCurrentBreakPoint] = useState(null)

  const containerRef = useRef(null)

  const handleResize =
    useCallback(() => {
      const breakPoint = responsive(breakPoints)

      setCurrentBreakPoint(breakPoint)

      if (!sameHeightAndWidth) {
        setItemHeight(breakPoint.rowHeight)

        return
      }

      setItemHeight(
        containerRef.current.clientWidth / breakPoint.numberOfColumns
      )

    }, [breakPoints])

  useLayoutEffect(() => {
    if ("ResizeObserver" in window) {
      const resizeObserver =
        new ResizeObserver(handleResize)

      resizeObserver.observe(containerRef.current)

      return () => {
        resizeObserver.unobserve(containerRef.current);
      }
    } else {
      handleResize()

      window.addEventListener("resize", handleResize)

      return () => {
        window.removeEventListener("resize", handleResize)
      }
    }
  }, [])

  const show =
    itemHeight !== null &&
    currentBreakPoint !== null

  return (
    <div
      id={id}
      ref={containerRef}
      style={{ overflow: "auto" }}
      className={className}
    >
      {!!headerComponent && headerComponent()}

      {show
        ?
        data.map(({ title, items, _id: sectionId }) => {
          if (items.length === 0) return null

          const numberOfSectionRows =
            Math.ceil((items.length / currentBreakPoint.numberOfColumns))

          const sectionHeight =
            numberOfSectionRows * itemHeight + sectionTitleHeight

          return (
            <VirtualGridWrapper
              sectionId={sectionId}
              key={title}
              title={title}
              data={items}
              containerRef={containerRef}
              keyField={keyField}
              offset={offset}
              sectionTitle={sectionTitle}
              renderItem={renderItem}
              breakPoints={breakPoints}
              sectionHeight={sectionHeight}
              listEmptyComponent={listEmptyComponent}
              sameHeightAndWidth={sameHeightAndWidth}
            />
          )
        })
        : null
      }
    </div>
  )
}

export default React.memo(SectionVirtualGrid)